var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['link', (_vm.isLight) ? 'light' : 'dark'],attrs:{"href":_vm.anchor},on:{"click":_vm.handler}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }